import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { usePopper } from '@/src/hooks/usePopper';
import { cn } from '@/src/util/ui';

const getCustomClasses = ({ disabled, isActive }) => {
  const customClasses = [];

  if (disabled) {
    customClasses.push('disabled');
  }

  if (isActive && !disabled) {
    customClasses.push('active');
  }

  return customClasses.length ? customClasses.join(' ') : '';
};

const EllipsisActionsContainer = ({
  disabled = false,
  isActive,
  children,
  buttonClassSettings = null,
}) => {
  const [isPopperOpen, popperAnchorEl, togglePopper] = usePopper({ anchorEl: null, open: false });

  // Styles to set for ellipsis button if active
  buttonClassSettings = {
    variant: 'style_unset',
    isActive: isPopperOpen,
    activeStyles: clsx(
      'tw-text-cfo-blue-700 tw-bg-cfo-blue-200 tw-border-cfo-blue-200 tw-rounded-[50px]'
    ),
  };

  const classes = getCustomClasses({
    disabled,
    isActive: open || isActive,
  });

  return (
    <div className="fileActionsContainer">
      <Button
        id={'ellipsis_action'}
        className={cn('tw-mr-0 tw-p-0', 'hover:tw-text-cfo-blue-700', classes)}
        buttonClassSettings={buttonClassSettings}
        disabled={disabled}
        onClick={togglePopper}
      >
        <Icon
          className={clsx('tw-text-[24px]', 'group-hover:tw-text-cfo-blue-700')}
          icon={ICONS.ellipsis_horizontal}
        />
      </Button>
      <Popper
        open={isPopperOpen}
        anchorEl={popperAnchorEl}
        placement="left-start"
        style={{ zIndex: 100 }}
      >
        <ClickAwayListener onClickAway={() => togglePopper(null)}>
          <div
            className={clsx(
              'tw-bg-white',
              'tw-min-w-[235px] tw-w-full',
              'tw-ml-[-10px]',
              'tw-rounded-[5px] tw-border-[1px] tw-border-solid tw-border-cfo-grey-500',
              'tw-shadow-[3px_4px_5px_0px_rgba(0,0,0,0.06)]'
            )}
          >
            {!disabled && children}
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default EllipsisActionsContainer;
